import ConfigurableBorder from './_configurable-border.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import ConfigurableFlexItem from './_configurable-flex-item.js'
import ConfigurableMargin from './_configurable-margin.js'

export default {
  name: 'SkeletonPart',
  values: {
    style: {
      width: '100%',
      height: '100%',
      $mixin: [
        {
          configSet: ConfigurableBorder,
        },
        {
          configSet: ConfigurableSizeBounds,
        },
        {
          configSet: ConfigurableFlexItem,
        },
        {
          configSet: ConfigurableMargin,
        },
      ],
    },
    svgSrc: '/images/generic/skeleton-part.svg#skeleton-part',
    fill: undefined,
    stroke: undefined,
  },
  meta: {
    extendable: false,
  },
}
